import { useEffect, useState } from "react"
import { getDepositoById, postDeposito, patchDeposito} from "../../services/DepositosServices"
import { DepositosFormContext } from "./DepositosContext"
import { useNavigate, useParams } from 'react-router-dom';

export const DepositosFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getDepositoByIdData(id)
    }, [])

    const getDepositoByIdData = async (id) => {
        let res = await getDepositoById(id)
        if (res) setReport(res)
    }

    const postDepositoData = async (body) => {
        const res = await postDeposito(body)
        if (res) navigate("/depositos");
    }

    const patchDepositoData = async (id, body) => {
        const res = await patchDeposito(id, body)
        if (res) navigate("/depositos");
    }

    return <DepositosFormContext.Provider value={{
        report,
        postDepositoData,
        patchDepositoData,
    }} >
        {children}
    </DepositosFormContext.Provider>
}